//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import view from '@/views';
import company from '../../Company/index';
import { getAll } from '../../../api/company';
import CreateCompanyModal from '../../Company/components/create-company-modal';

export default {
    name: 'select-company-modal',
    components: { CreateCompanyModal, company },
    props: {
        onSelected: Function
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            searchInput: {},
            columns: [
                {
                    type: 'index',
                    align: 'center',
                    maxWidth: 66
                },
                {
                    title: '公司名称',
                    key: 'name',
                    align: 'center'
                },
                // {
                //     title: '公司电话',
                //     key: 'phone',
                //     align: 'center'
                // },
                // {
                //     title: '公司地址',
                //     key: 'address',
                //     align: 'center'
                // },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center'
                }
            ],
            createCompanyModal: false,
            list: []
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(size) {
            this.pageSize = size;
            this.getPage();
        },
        getPage() {
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.searchInput.maxResultCount = this.pageSize;
            this.loading = true;
            getAll(this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        selectedCompany(row) {
            this.onSelected(row);

        }
    },
    created() {
        this.getPage();
    }
};
